<template>
  <div class='body'>
    <div class='mini-schedule'>
      <div id='test'></div>
    </div>
    <div class='heads-up-list'>
      <h3>Heads Up:</h3>
      <notificationList/>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import notificationList from "../notificationList";
function objToArray(obj) {
  var result = [];
  for (var key in obj) {
    result.push(obj[key]);
  }
  return result;
}
export default {
  props: ["id"],
  data() {
    return {
      now: DateTime.local().toJSDate(),
      event: {
        start: null,
        end: null,
        name: null,
        sessions: []
      }
    };
  },
  methods: {
    getEvent: function() {
      return this.$store
        .dispatch("events/get", { id: this.id })
        .then(() => this.$store.getters["events/event"](this.id));
    },
    drawMiniScheduler() {
      var start = this.event.start;
      var end = this.event.end;
      var rooms = objToArray(this.event.rooms) || [];
      rooms.unshift({
        name: "unset",
        id: null
      });
      var sessions = [];
      for (var id in this.event.sessions) {
        sessions.push(this.event.sessions[id]);
      }
      var now = this.now;
      var roomCount = rooms.length;
      var columnWidth = 100;
      var pixelsPerDay = 1500;
      var height = end.diff(start, "days").days * pixelsPerDay;
      var y = d3
        .scaleTime()
        .domain([start, end])
        .range([0, height]);

      var roomScale = d3
        .scaleBand()
        .domain(rooms.map(r => r.name))
        .range([0, roomCount * columnWidth]);

      var axisLeft = d3.axisLeft(y).ticks(d3.timeMinute.every(30));
      var axisTop = d3.axisTop(roomScale);

      var gridlines = d3
        .axisLeft(y)
        .ticks(d3.timeMinute.every(30))
        .tickFormat("")
        .tickSize(-1 * height);

      // chart container
      var chart = d3
        .select("#test")
        .append("svg:svg")
        .attr("height", () => height)
        .attr("width", () => roomCount * columnWidth + 51);

      // top axis
      chart
        .append("g")
        .attr("transform", "translate(50,50)")
        .call(axisTop);

      // left axis
      chart
        .append("g")
        .attr("transform", "translate(50,50)")
        .call(axisLeft);

      // horizontal gridlines
      chart
        .append("g")
        .attr("transform", "translate(50,50)")
        .attr("class", "gridline")
        .call(gridlines)
        .selectAll("line")
        .attr("stroke", "");

      // session boxes
      chart
        .append("g")
        .attr("transform", "translate(51,51)")
        .selectAll("rect")
        .data(sessions)
        .enter()
        .append("svg:rect")
        .attr("class", "mini-cal-period")
        .attr("x", v => 
            rooms.indexOf(rooms.filter(r => r.id == v.room)[0]) * columnWidth
        )
        .attr("y", v => y(v.start))
        .attr("width", 100)
        .attr("height", v => y(v.end) - y(v.start));

      // current time line
      chart
        .append("svg:rect")
        .attr("y", v => y(now))
        .attr("transform", "translate(45,50)")
        .attr("width", roomCount * columnWidth + 5)
        .attr("height", 1)
        .attr("fill", "red");

      // vertical gridlines
      chart
        .append("g")
        .attr("transform", "translate(50,50)")
        .attr("class", "gridline")
        .selectAll("line")
        .data(rooms)
        .enter()
        .append("svg:line")
        .attr("x1", (r, i) => (i + 1) * columnWidth)
        .attr("x2", (r, i) => (i + 1) * columnWidth)
        .attr("y1", v => y(start.toJSDate()))
        .attr("y2", v => y(end.toJSDate()));
    }
  },
  beforeMount: function() {
    setInterval(() => {
      this.now = DateTime.local().toJSDate();
    }, 60 * 1000);
  },
  components: {
    notificationList
  },
  mounted: function() {
    this.getEvent(this.id).then(event => {
      this.event = event;
      this.drawMiniScheduler();
    });
  }
};
</script>

<style scoped lang='scss'>
.dashboard-container {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.dashboard-header {
  flex-shrink: 0;
  background: white;
  color: $primary;
  border-bottom: 1px solid $gray-4;
  border-top: 6px solid $secondary;

  .profile-btn {
    color: $punch;
    padding: 8px 16px;
    border-radius: 4px;
    box-shadow: 0 1px 5px hsla(0, 0%, 0%, 0.2);
    font-size: 2rem;
  }

  .header-upper {
    h2 {
      letter-spacing: 6px;
    }
    padding: 4px 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .header-lower {
    margin-top: 16px;
    font-weight: 800;
    font-size: 2.2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    > span {
      margin: 0px 24px;
    }
  }
  .header-nav {
    margin-top: 48px;
    font-size: 1.2rem;
    font-weight: 800;
    display: flex;
    flex-direction: row;
    justify-content: center;
    > div {
      margin: 0px 30px;
      padding: 0px 24px;
    }
    > div:hover {
      color: $secondary;
      border-bottom: 6px solid $secondary;
    }
    .selected {
      color: $secondary;
      border-bottom: 6px solid $secondary;
    }
  }
}
.body {
  color: $primary;
  padding: 0px 20px 0px 20px;
  background: white;
  border-radius: 4px;
  border: 1px solid $gray-4;
}
.heads-up-list {
  flex-shrink: 0;
}
.mini-schedule {
  flex-grow: 1;
  margin-right: 32px;
  max-height:400px;
  overflow-y: auto;
}
</style>
<style  lang='scss'>
.gridline {
  stroke: $gray-3;
}
.mini-cal-period {
  fill: $gray-3;
  stroke: hsl(0, 0%, 75.3%);
}
</style>



// WEBPACK FOOTER //
// src/components/event/home.vue